var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroupPeople(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 9C9 7.3 10.3 6 12 6C13.7 6 15 7.3 15 9C15 10.7 13.7 12 12 12C10.3 12 9 10.7 9 9ZM12 14C7.4 14 6 17.3 6 17.3V19H18V17.3C18 17.3 16.6 14 12 14Z",
    fill: "#9597AB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 11C19.8807 11 21 9.88071 21 8.5C21 7.11929 19.8807 6 18.5 6C17.1193 6 16 7.11929 16 8.5C16 9.88071 17.1193 11 18.5 11Z",
    fill: "#9597AB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 13C17.3 13 16.4 13.3 15.7 13.8C18 14.9 18.9 16.8 18.9 17V17.1H23V15.8C23 15.7 21.9 13 18.5 13Z",
    fill: "#9597AB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 11C19.8807 11 21 9.88071 21 8.5C21 7.11929 19.8807 6 18.5 6C17.1193 6 16 7.11929 16 8.5C16 9.88071 17.1193 11 18.5 11Z",
    fill: "#9597AB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 13C17.3 13 16.4 13.3 15.7 13.8C18 14.9 18.9 16.8 18.9 17V17.1H23V15.8C23 15.7 21.9 13 18.5 13Z",
    fill: "#9597AB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 11C6.88071 11 8 9.88071 8 8.5C8 7.11929 6.88071 6 5.5 6C4.11929 6 3 7.11929 3 8.5C3 9.88071 4.11929 11 5.5 11Z",
    fill: "#9597AB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 13C6.7 13 7.6 13.3 8.3 13.8C6 14.9 5.1 16.8 5.1 17V17.1H1V15.8C1 15.7 2.1 13 5.5 13Z",
    fill: "#9597AB"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupPeople);
export default __webpack_public_path__ + "static/media/group_people.e88e8a4342c0a0a4a9a940d5c7a97102.svg";
export { ForwardRef as ReactComponent };